import React, { useState } from 'react';
import './checkbox.scss';

type CheckboxProps = {
  id: string,
  onChange: any,
  initialState?: boolean
}

const Checkbox = (props: CheckboxProps) => {
  const { id, onChange, initialState = false } = props;
  const [checked, setChecked] = useState<boolean>(initialState);

  const className = checked ? 'icon-tick' : undefined;

  const change = () => {
    const isChecked = !checked;
    setChecked(isChecked);
    onChange(isChecked);
  }

  return (
    <button type="button" className="checkbox" onClick={change}>
      <i id={id} className={className}></i>
    </button>
  );
}

export default Checkbox;